/* Hazii Studios — Maison layer: product rail arrows + progress, header scroll state */
(function () {
	function railInit(rail) {
		if (rail._hzRail) return;
		var track = rail.querySelector('[data-hz-rail-track]');
		if (!track) return;
		rail._hzRail = true;
		var bar = rail.querySelector('[data-hz-rail-progress]');
		var prev = rail.querySelector('[data-hz-rail-prev]');
		var next = rail.querySelector('[data-hz-rail-next]');
		var ticking = false;

		function update() {
			ticking = false;
			var max = track.scrollWidth - track.clientWidth;
			var scrollable = max > 4;
			rail.classList.toggle('hz-rail--static', !scrollable);
			if (!scrollable) return;
			var x = Math.min(Math.max(track.scrollLeft, 0), max);
			var w = Math.max(track.clientWidth / track.scrollWidth, 0.12);
			if (bar) {
				bar.style.setProperty('--hz-rail-w', (w * 100).toFixed(2) + '%');
				bar.style.setProperty('--hz-rail-x', ((x / max) * ((1 - w) / w) * 100).toFixed(2) + '%');
			}
			if (prev) prev.disabled = x <= 2;
			if (next) next.disabled = x >= max - 2;
		}
		function queue() {
			if (!ticking) { ticking = true; requestAnimationFrame(update); }
		}
		function step(dir) {
			var item = track.querySelector('.hz-rail__item') || track.firstElementChild;
			var w = item ? item.getBoundingClientRect().width : track.clientWidth / 3;
			var per = Math.max(1, Math.floor(track.clientWidth / w) - 1);
			track.scrollBy({ left: dir * per * w, behavior: 'smooth' });
		}
		track.addEventListener('scroll', queue, { passive: true });
		if (prev) prev.addEventListener('click', function () { step(-1); });
		if (next) next.addEventListener('click', function () { step(1); });
		track.addEventListener('keydown', function (e) {
			if (e.target !== track) return;
			if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
			if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
		});
		if ('ResizeObserver' in window) new ResizeObserver(queue).observe(track);
		else window.addEventListener('resize', queue);
		update();
	}

	function init(scope) {
		(scope || document).querySelectorAll('[data-hz-rail]').forEach(railInit);
	}

	var root = document.documentElement;
	var scrolled = false;
	function onScroll() {
		var s = window.scrollY > 8;
		if (s !== scrolled) { scrolled = s; root.classList.toggle('hz-scrolled', s); }
	}
	window.addEventListener('scroll', onScroll, { passive: true });

	document.addEventListener('shopify:section:load', function (e) { init(e.target); });
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); onScroll(); });
	else { init(); onScroll(); }
})();
